var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenerateTrackLeads(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221,
    height: 221,
    viewBox: "0 0 221 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Generate_Track_Leads",
    "data-name": "Generate & Track Leads",
    transform: "translate(-16774 -8411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_581",
    "data-name": "Ellipse 581",
    cx: 110.5,
    cy: 110.5,
    r: 110.5,
    transform: "translate(16774 8411)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(16813.996 8450.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19698",
    "data-name": "Path 19698",
    d: "M33.077,349.468,1.209,381.336a4.131,4.131,0,0,0,0,5.842l5.842,5.842a4.132,4.132,0,0,0,5.842,0l31.868-31.868A45.815,45.815,0,0,1,33.077,349.468Z",
    transform: "translate(0 -253.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19699",
    "data-name": "Path 19699",
    d: "M379.211,411.2a22,22,0,0,1-28.007,1.324c-.554-.415-1.084-.86-1.6-1.326A23.372,23.372,0,0,0,341,429.322v5.508a4.131,4.131,0,0,0,4.131,4.131h38.557a4.131,4.131,0,0,0,4.131-4.131v-5.508A23.372,23.372,0,0,0,379.211,411.2Z",
    transform: "translate(-247.088 -297.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19700",
    "data-name": "Path 19700",
    d: "M391.377,329.54a13.77,13.77,0,1,0-3.3-27.139,45.44,45.44,0,0,1-9.863,17.426A13.8,13.8,0,0,0,391.377,329.54Z",
    transform: "translate(-274.056 -218.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19701",
    "data-name": "Path 19701",
    d: "M391.493,109.206a21.993,21.993,0,0,1-29.6,0,23.641,23.641,0,0,0-4.323,4.637,45.583,45.583,0,0,1,15.67,23.119h22.73a4.131,4.131,0,0,0,4.131-4.131v-5.508A23.372,23.372,0,0,0,391.493,109.206Z",
    transform: "translate(-259.094 -79.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19702",
    "data-name": "Path 19702",
    d: "M8.607,109.206A23.372,23.372,0,0,0,0,127.326v5.508a4.131,4.131,0,0,0,4.131,4.131h22.73a45.58,45.58,0,0,1,15.67-23.119,23.641,23.641,0,0,0-4.323-4.637,21.993,21.993,0,0,1-29.6,0Z",
    transform: "translate(0 -79.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19703",
    "data-name": "Path 19703",
    d: "M48.77,27.54A13.77,13.77,0,1,1,62.54,13.77,13.786,13.786,0,0,1,48.77,27.54Z",
    transform: "translate(-25.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19704",
    "data-name": "Path 19704",
    d: "M390.77,27.54a13.77,13.77,0,1,1,13.77-13.77A13.786,13.786,0,0,1,390.77,27.54Z",
    transform: "translate(-273.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19705",
    "data-name": "Path 19705",
    d: "M201.13,322.574a37.147,37.147,0,0,0,30.223,0v-7.055a15.124,15.124,0,0,0-30.223,0Z",
    transform: "translate(-145.738 -218.103)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_627",
    "data-name": "Ellipse 627",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(62 58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19706",
    "data-name": "Path 19706",
    d: "M158.18,121a37.164,37.164,0,0,0-23.374,66.07v-2.058c0-.05,0-.1,0-.15a23.447,23.447,0,0,1,11.511-19.324,16.524,16.524,0,1,1,23.72,0,23.447,23.447,0,0,1,11.511,19.324c0,.05,0,.1,0,.15v2.058A37.164,37.164,0,0,0,158.18,121Z",
    transform: "translate(-87.676 -87.676)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateTrackLeads);
export default __webpack_public_path__ + "static/media/Generate _ Track Leads.ad7c827e0ee9f0e3ad0feeb9ed0f56e0.svg";
export { ForwardRef as ReactComponent };